import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Globals } from '../../../_globals/globals';

import { Translation } from '../../../_languages/translations';

@Component({
  selector: 'app-master-show',
  templateUrl: './master-show.component.html'
})

export class MasterShowComponent implements OnInit {

  // Para el control del diccionario de traducción.
  tr: {};

  title: string;
  subtitle: string;

  permissions: string;
  permissionList: any;

  sectionPermisionList: any;

  constructor(
    public router: Router,
    private globals: Globals,
    public trans: Translation
  ) {}

  ngOnInit() {

    this.tr = this.trans.vocabulary;

    this.title = this.tr['ms2_title'];
    this.subtitle = this.tr['ms2_subtitle'];


    this.permissions = localStorage.getItem('permissions');
    console.log('-> -> Iniciando Master-Show permissions:' + this.permissions);

    // No se va a usar en esta sección.
    this.permissionList = this.globals.permissionList; // ['Administrador', 'Supervisor', 'Comercial'];

    // Se inicializan los permisos de los apartados de esta vista.
    // MEJORA: Sacar el listado de permisos de cada sección desde tablas configuradas en la BD.
    // Esto permitiría poder incluir un maestro para el control de visibilidad de secciones según perfil.
    this.sectionPermisionList = this.globals.sectionPermisionList;

  } // End function ngOnInit

  // Función que comprueba si una sección, cuyo nombre es pasado como parámetro, es visible o no al usuario actual.
  checkPermision(sectionIn: string): boolean {
    // console.log(' --> Apartado a comprobar: ' + sectionIn);

    if (this.sectionPermisionList[sectionIn] && this.sectionPermisionList[sectionIn].indexOf(this.permissions) >= 0) {
      return true;
    } else {
      return false;
    }
  } // End function checkPermision

} // End MasterShowComponent
